import { BreakpointObserver } from '@angular/cdk/layout';
import { Injectable, inject } from '@angular/core';
import { map, Observable, tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ScreenService {
  private observer = inject(BreakpointObserver);


  constructor() { }

  get isBelowSm$(): Observable<boolean> {
    return this.observer.observe(['(max-width: 575px)']).pipe(map(state => state.matches));
  }

  get isBelowMd$(): Observable<boolean> {
    return this.observer.observe(['(max-width: 767px)']).pipe(map(state => state.matches));
  }

  get isBelowLg$(): Observable<boolean> {
    return this.observer.observe(['(max-width: 991px)']).pipe(map(state => state.matches));
  }

  get isBelowXl$(): Observable<boolean> {
    return this.observer.observe(['(max-width: 1199px)']).pipe(map(state => state.matches));
  }

  get isAboveSm$(): Observable<boolean> {
    return this.isBelowSm$.pipe(map(matches => !matches));
  }

  get isAboveMd$(): Observable<boolean> {
    return this.isBelowMd$.pipe(map(matches => !matches));
  }

  get isAboveLg$(): Observable<boolean> {
    return this.isBelowLg$.pipe(map(matches => !matches));
  }

  get isAboveXl$(): Observable<boolean> {
    return this.isBelowXl$.pipe(map(matches => !matches));
  }
}
